import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25847b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gallery" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (src, index) => {
        return (_openBlock(), _createElementBlock("img", {
          key: index,
          src: src,
          alt: `Photo ${index + 1}`,
          class: "photo"
        }, null, 8, _hoisted_3))
      }), 128))
    ])
  ]))
}